///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//

const { trim } = require("lodash");

///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.common = abcsetup.rfq.bid_requests.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.common.items = [];
abcsetup.rfq.bid_requests.common.removeItems = [];
abcsetup.rfq.bid_requests.common.oldVals = [];
abcsetup.rfq.bid_requests.common.itemVals = [];
abcsetup.rfq.bid_requests.common.deadNetTimeout = null;
abcsetup.rfq.bid_requests.common.annualUsageTimeout = null;
abcsetup.rfq.bid_requests.common.qtyNeededTimeout = null;
abcsetup.rfq.bid_requests.common.addUsageTimeout = null;
abcsetup.rfq.bid_requests.common.vendors = [];
// abcsetup.rfq.bid_requests.common.incumbents = [];
abcsetup.rfq.bid_requests.common.parentOrgs = [];


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.common = {
    init: function () {
        abcsetup.rfq.bid_requests.common.oldVals = [];

        // "All suppliers" clicked
        $('#all_suppliers').bind('change', function () {
            if ($(this).prop('checked')) {
                $('#suppliers').addClass('disabled').attr('disabled', true);
                $('#suppliers').attr('required', false);
            } else {
                $('#suppliers').removeClass('disabled').attr('disabled', false);
                $('#suppliers').attr('required', true);
            }
        });

        // Update the event name on rfq_bid_type_id, gcn_family and start_date change
        $('#rfq_bid_type_id, #start_date, #gcn_family').bind('change', function () {
            var id = $(this).attr('id');
            var value = $(this).find('option:selected').text() || $(this).val();

            if (id=='rfq_bid_type_id'){
                $('#show_dead_net').val(false).trigger('change');
                if ($(this).find('option:selected').data('showdeadnet')) {
                    $('#show_dead_net').val(true).trigger('change');
                }
            }

            // if ($('#rfq_bid_type_id').val()==23 || $('#rfq_bid_type_id').val()==24){
            //     // Force Monday selection
            //     var date = new Date($('#start_date').val());
            //     var day = date.getDay();
            //     if(day === 1) {
            //         // Monday
            //     } else {
            //         return false;
            //     }
            // }

            if (value != '' && abcsetup.rfq.bid_requests.common.oldVals[id] != '') {
                console.log('Replace ' + abcsetup.rfq.bid_requests.common.oldVals[id] + ' ==> ' + value);
                $('#name').val($('#name').val().replace(abcsetup.rfq.bid_requests.common.oldVals[id], value));
                abcsetup.rfq.bid_requests.common.oldVals[id] = value;
            }
        });

        // Bid type changed
        $('#rfq_bid_type_id').on('change', function () {
            $('#items').trigger('change');

            // Default start_immediately to checked for bid type 28
            if ($(this).val()==28){
                $("#start_immediately").attr('checked',true).trigger('change');
            }

            // Toggle the customer select field (needed for bid id 29)
            if ($(this).val()==29){
                $("#customer_select").show();
            } else {
                $("#customer_select").hide();
            }

            // Default to incumbent suppliers for bid type 28 and 29
            if ($(this).val()==28 || $(this).val()==29) {
                if (!$('#submit_bids_btn')[0]) {
                    $("#incumbent_suppliers").attr('checked',true).trigger('change');
                }
            }
        });

        // The items list has changed
        $('#items').on('change', function () {
            abcsetup.rfq.bid_requests.common.updateDeadNetPricing();
            abcsetup.rfq.bid_requests.common.updateAnnualUsage();
            abcsetup.rfq.bid_requests.common.updateQtyNeeded();
            abcsetup.rfq.bid_requests.common.updateAdditionalUsage();
            abcsetup.rfq.bid_requests.common.updateIncumbentSuppliers();
        }).trigger('change');

        // The item selector button has been clicked
        $(document).on('click', '.btn-select-item', function () {
            abcsetup.launchWin('/rfq/bid_requests/select_item', 'select_item');
        });

        // The start immediately checkbox was clicked
        $('#start_immediately').bind('change', function () {
            if ($(this).prop('checked')) {
                var date = new Date();
                $('#start_date').val(moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                $('#start_date').addClass('disabled').attr('readonly', true);
            } else {
                $('#start_date').removeClass('disabled').attr('readonly', false);
            }
            $('#start_date').trigger('change');
        }).trigger('change');

        $(function() {
            $('#items').on('select2:select',function(e) {
                var item_sap = e.params.data.id;
                abcsetup.rfq.bid_requests.common.searchVendor(item_sap,'select');
            });

            $('#items').on('select2:unselect', function (e) {
                var item_sap = e.params.data.id;
                abcsetup.rfq.bid_requests.common.searchVendor(item_sap,'unselect');
            });
        });

        // Keep track of old vals to update the name with
        abcsetup.rfq.bid_requests.common.oldVals['rfq_bid_type_id'] = $('#rfq_bid_type_id option:selected').text();
        abcsetup.rfq.bid_requests.common.oldVals['start_date'] = $('#start_date').val();
        abcsetup.rfq.bid_requests.common.oldVals['gcn_family'] = $('#gcn_family option:selected').text();
        abcsetup.rfq.bid_requests.common.vendors = $('#suppliers').val();
        // abcsetup.rfq.bid_requests.common.incumbents = [];
        abcsetup.rfq.bid_requests.common.parentOrgs = [];
    },

    /**
     * Import the specified items
     * @param {[]} vals
     */
    importItems: function (vals) {
        console.log('importItems',vals);
        abcsetup.rfq.bid_requests.common.itemVals = vals;
        // No items were loaded
        if (vals.length === 0) {
            abcsetup.alerts.show('No items found', '<div class="alert alert-danger text-center">No items were found in the specified import file</div>');
            return;
        }

        $('#annual_usage_table').data('overrides', vals);
        $('#qty_needed_table').data('overrides', vals);
        $('#additional_usage_table').data('overrides', vals);
        $('#dead_net_table').data('overrides', vals);
        $(vals).each(function () {
            // Toggle the existing item or add it
            if ($("#items").find("option[value=" + this.value + "]").length) {
                $("#items").find("option[value=" + this.value + "]").prop('selected', true).trigger('change');
            } else {
                const newOption = new Option(this.text, this.value, true, true);
                $('#items').append(newOption).trigger('change');
            }
        });

        abcsetup.alerts.show('Item import', '<div class="alert alert-success text-center"><b>' + vals.length + ' items</b> were successfully imported</div>');
    },

    /**
     * Import the specified suppliers
     * @param {*} vals
     */
    importSuppliers: function (vals) {
        var selected = [];

        if (vals.length == 0) {
            abcsetup.alerts.show('No suppliers found', '<div class="alert alert-danger text-center">No suppliers were found in the specified import file</div>');
            return;
        }

        $(vals).each(function () {
            selected.push(this.value);
        });


        if ($('#all_suppliers').prop('checked')) {
            $('#all_suppliers').prop('checked', false).trigger('change');
        }

        $("#suppliers").val(selected).trigger("change");
        abcsetup.alerts.show('Supplier import', '<div class="alert alert-success text-center"><b>' + selected.length + ' suppliers</b> were successfully imported</div>');
    },

    /**
     * Update the dead net pricing table
     */
    updateDeadNetPricing: function () {
        clearTimeout(abcsetup.rfq.bid_requests.common.deadNetTimeout);

        abcsetup.rfq.bid_requests.common.deadNetTimeout = setTimeout(function () {
            const overrides = $('#dead_net_table').data('overrides') || [];
            const haveOverrideVal = sapNum => Boolean(overrides.find(item => String((item || {}).value) === String(sapNum)));
            const getOverrideVal = sapNum => (overrides.find(item => String((item || {}).value) === String(sapNum)) || {}).requested_dead_net;

            $($('#items').val()).each(function () {
                const display = $('#items option[value=' + this + ']').text();

                if ($('#dead_net_table tr.' + this).length === 0) {

                    axios.post('/api/coupa/' + this).then(response => {
                        let val = haveOverrideVal(this)
                            ? getOverrideVal(this)
                            : response.data.deadnetcost;

                        // Get the old dead net value (if it exists)
                        val = $('#old_requested_dead_net_' + this).val() || val;

                        // If dead net is 0, force the value to an empty string to fix validation issues.
                        val = val==0 ? '' : val;

                        $('#dead_net_table')
                            .append('<tr class="item valid ' + this + '">\
                                <td>' + display + '</td>\
                                <td><input type="number" name="requested_dead_net[' + this + ']" class="form-control" min="0.01" step="0.01" max="999999" value="' + val + '" requiredIf="rfq_bid_type_id=24"></td>\
                            </tr>');
                    });
                }

                $('#dead_net_table tr.' + this).addClass('valid');
            });

            $('#dead_net_table tr.item:not(.valid)').remove();
            $('#dead_net_table tr').removeClass('valid');
        }, 1250);
    },

    /**
     * Update the dead net pricing table
     */
    updateAnnualUsage: function () {
        clearTimeout(abcsetup.rfq.bid_requests.common.annualUsageTimeout);

        var items = abcsetup.rfq.bid_requests.common.itemVals;
        abcsetup.rfq.bid_requests.common.annualUsageTimeout = setTimeout(function () {
            const overrides = $('#annual_usage_table').data('overrides') || [];
            const haveOverrideVal = sapNum => Boolean(overrides.find(item => String((item || {}).value) === String(sapNum)));
            const getOverrideVal = sapNum => (overrides.find(item => String((item || {}).value) === String(sapNum)) || {}).annual_usage;

            $($('#items').val()).each(function () {
                const display = $('#items option[value=' + this + ']').text();
                if ($('#annual_usage_table tr.' + this).length === 0) {
                    // Load the coupa product
                    axios.post('/api/coupa/' + this).then(response => {
                        let val = 0;

                        if (haveOverrideVal(this)) {
                            val = getOverrideVal(this)
                        } else if ($('#formulary_type').val() === 'PharmaGen') {
                            val = response.data.pharmagen_annual_usage;
                        } else if ($('#formulary_type').val() === 'PRxO') {
                            val = response.data.prxo_annual_usage;
                        }

                        // Get the old annual usage value (if it exists)
                        val = $('#old_annual_usage_' + this).val() || val;

                        // Should we disable the annual_usage field
                        var disabled = $('#extending').length ? 'disabled' : '';

                        $('#annual_usage_table').append('<tr class="item valid ' + this + '">\
                                                        <td>' + display + '</td>\
                                                        <td><input type="number" name="annual_usage[' + this + ']" class="form-control" min="0" step="0.01" value="' + val + '" showIf="rfq_bid_type_id!=23" required ' + disabled + '></td>\
                                                    </tr>');
                    });
                }

                $('#annual_usage_table tr.' + this).addClass('valid');
            });

            $('#annual_usage_table tr.item:not(.valid)').remove();
            $('#annual_usage_table tr').removeClass('valid');
        }, 1250);
    },

    /**
     * Update the dead net pricing table
     */
    updateQtyNeeded: function () {
        clearTimeout(abcsetup.rfq.bid_requests.common.qtyNeededTimeout);

        var items = abcsetup.rfq.bid_requests.common.itemVals;
        abcsetup.rfq.bid_requests.common.qtyNeededTimeout = setTimeout(function () {
            const overrides = $('#qty_needed_table').data('overrides') || [];
            const haveOverrideVal = sapNum => Boolean(overrides.find(item => String((item || {}).value) === String(sapNum)));
            const getOverrideVal = sapNum => (overrides.find(item => String((item || {}).value) === String(sapNum)) || {}).qty_needed;

            $($('#items').val()).each(function () {
                const display = $('#items option[value=' + this + ']').text();

                if ($('#qty_needed_table tr.' + this).length === 0) {
                    // Load the coupa product
                    axios.post('/api/coupa/' + this).then(response => {
                        let val = 0;
                        // let val2 = 0;

                        // Get the old annual usage value (if it exists)
                        val = $('#old_qty_needed_' + this).val() || val;
                        // val2 = $('#old_size_' + this).val() || val2;

                        // Should we disable the qty_needed field
                        var disabled = $('#extending').length ? 'disabled' : '';

                        var sapNum = this;
                        if (typeof items === "undefined") {
                            $('#qty_needed_table').append('<tr class="item valid ' + this + '">\
                                                            <td>' + display + '</td>\
                                                            <td><input type="number" id="qty_needed[' + this + ']" name="qty_needed[' + this + ']" class="form-control" min="0.01" step="0.01" max="999999" value="' + val + '" required ' + disabled + '></td>\
                                                        </tr>');
                        }
                        else {
                            $.each(items, function (i, obj) {
                                if (obj.value == sapNum) {
                                    $('#qty_needed_table').append('<tr class="item valid ' + sapNum + '">\
                                                            <td>' + display + '</td>\
                                                            <td><input type="number" id="qty_needed[' + sapNum + ']" name="qty_needed[' + sapNum + ']" class="form-control" min="0.01" step="0.01" max="999999" value="' + obj.qty_needed + '" required ' + disabled + '></td>\
                                                        </tr>');
                                }
                            });
                        }
                    });
                }

                $('#qty_needed_table tr.' + this).addClass('valid');
            });

            $('#qty_needed_table tr.item:not(.valid)').remove();
            $('#qty_needed_table tr').removeClass('valid');
        }, 1250);
    },

    /**
     * Update the additional usage pricing table
     */
    updateAdditionalUsage: function () {
        clearTimeout(abcsetup.rfq.bid_requests.common.addUsageTimeout);

        var items = abcsetup.rfq.bid_requests.common.itemVals;
        abcsetup.rfq.bid_requests.common.addUsageTimeout = setTimeout(function () {
            const overrides = $('#additional_usage_table').data('overrides') || [];
            const haveOverrideVal = sapNum => Boolean(overrides.find(item => String((item || {}).value) === String(sapNum)));
            const getOverrideVal = sapNum => (overrides.find(item => String((item || {}).value) === String(sapNum)) || {}).additional_usage;

            $($('#items').val()).each(function () {
                console.log('updateAdditionalUsage',this)
                const display = $('#items option[value=' + this + ']').text();

                if ($('#additional_usage_table tr.' + this).length === 0) {
                    // Load the coupa product
                    axios.post('/api/coupa/' + this).then(response => {
                        let val = 0;
                        let val2 = '';

                        // Get the old annual usage value (if it exists)
                        val = $('#old_additional_usage_' + this).val() || val;
                        val2 = $('#old_requested_by_' + this).val() || val2;

                        if (val == 0) {
                            val = null;
                        }

                        // Should we disable the annual_usage field
                        var disabled = $('#extending').length ? 'disabled' : '';

                        var sapNum = this;
                        if (typeof items === "undefined") {
                            $('#additional_usage_table').append(`
                                <tr class="item valid ${this}">
                                    <td>${display}</td>
                                    <td><input type="number" id="additional_usage[${this}]" name="additional_usage[${this}]" class="form-control" min="0.01" step="0.01" max="999999" value="${val}" requiredIf="rfq_bid_type_id=28" ${disabled}></td>
                                    <td>
                                        <select id="requested_by_${sapNum}" name="requested_by[${sapNum}]" class="select form-control" requiredIf="rfq_bid_type_id=28">
                                            <option value="">- select -</option>
                                            <option value="Amazon/Pillpack">Amazon/Pillpack</option>
                                            <option value="Costco">Costco</option>
                                            <option value="Humana">Humana</option>
                                            <option value="Kaiser">Kaiser</option>
                                            <option value="Meijer">Meijer</option>
                                            <option value="Publix">PharMerica</option>
                                            <option value="Publix">Publix</option>
                                            <option value="Sam's Club">Sam's Club</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        <div class="mt-2" showIf="requested_by_${sapNum}=Other">
                                            <label>Enter Other:</label>
                                            <input type="text" id="requested_by_other[${sapNum}]" name="requested_by_other[${sapNum}]" class="form-control" value="" requiredIf="rfq_bid_type_id=28" ${disabled}>
                                        </div>
                                    </td>
                                </tr>
                            `);
                        } else {
                            $.each(items, function (i, obj) {
                                console.log('in the else, obj',obj);
                                if (obj.value == sapNum) {
                                    $('#additional_usage_table').append(`
                                        <tr class="item valid ${sapNum}">
                                            <td>${display}</td>
                                            <td><input type="number" id="additional_usage[${sapNum}]" name="additional_usage[${sapNum}]" class="form-control" min="0.01" step="0.01" max="999999" value="${obj.additional_usage}" requiredIf="rfq_bid_type_id=28" ${disabled}></td>
                                            <td><input type="text" id="requested_by[${sapNum}]" name="requested_by[${sapNum}]" class="form-control test2" value="${obj.requested_by}" requiredIf="rfq_bid_type_id=28" ${disabled}></td>
                                        </tr>
                                    `);
                                }
                            });
                        }
                    });
                }

                $('#additional_usage_table tr.' + this).addClass('valid');
            });

            $('#additional_usage_table tr.item:not(.valid)').remove();
            $('#additional_usage_table tr').removeClass('valid');
        }, 1250);
    },

    /**
     * Update the Incumbent Suppliers table
     */
    updateIncumbentSuppliers: function () {
        clearTimeout(abcsetup.rfq.bid_requests.common.updateIncumbentTimeout);
        var items = abcsetup.rfq.bid_requests.common.itemVals;
        abcsetup.rfq.bid_requests.common.updateIncumbentTimeout = setTimeout(function () {
            $($('#items').val()).each(function () {
                if ($('#incumbent_suppliers_table tr.' + this).length === 0) {
                    // Load the coupa product
                    axios.post('/api/coupa/' + this).then(response => {
                        $('#incumbent_suppliers_table').append('<tr class="item valid ' + this + '">\
                                                        <td>(' + response.data.abc8 + ') ' + response.data.itemdescfull + '</td>\
                                                        <td>' + response.data.vendor8 + '</td>\
                                                        <td>' + response.data.parent_vendor + '</td>\
                                                        <td>' + response.data.vendorname + '</td>\
                                                    </tr>');
                        abcsetup.rfq.bid_requests.common.parentOrgs.push(response.data.parent_vendor);
                        // abcsetup.rfq.bid_requests.common.incumbents.push(response.data.vendor8);
                        $('#incumbents').trigger('change');
                    });
                }

                $('#incumbent_suppliers_table tr.' + this).addClass('valid');
            });
            $('#incumbent_suppliers_table tr.item:not(.valid)').each(function(){
                // var vendor8 = $.trim($(this).find("td").eq(1).html());
                var parent_vendor = $.trim($(this).find("td").eq(2).html());
                // console.log('Vendor: ',vendor8);
                // var index = abcsetup.rfq.bid_requests.common.incumbents.indexOf(vendor8);
                // if (index > -1) {
                //     abcsetup.rfq.bid_requests.common.incumbents.splice(index, 1);
                // }
                console.log('Parent Vendor: ',parent_vendor);
                var index = abcsetup.rfq.bid_requests.common.parentOrgs.indexOf(parent_vendor);
                if (index > -1) {
                    abcsetup.rfq.bid_requests.common.parentOrgs.splice(index, 1);
                }
                $(this).remove();
                $('#incumbents').trigger('change');
            });
            abcsetup.rfq.bid_requests.common.checkIncumbents();
            $('#incumbent_suppliers_table tr').removeClass('valid');
        }, 1250);
    },

    checkIncumbents: function(){
        clearTimeout(abcsetup.rfq.bid_requests.common.checkIncumbentTimeout);
        $('.btn.submit').attr('title','Save event and submit to suppliers').attr('disabled',false);

        abcsetup.rfq.bid_requests.common.checkIncumbentTimeout = setTimeout(function () {
            if ($('#rfq_bid_type_id').val()==24 || $('#rfq_bid_type_id').val()==28 || $('#rfq_bid_type_id').val()==29){
                var incumbentsArray = new Array();
                nullitems = 0;
                if (abcsetup.rfq.bid_requests.common.parentOrgs.length > 1) {
                    for (i = 0;i < abcsetup.rfq.bid_requests.common.parentOrgs.length;i++) {
                        if (abcsetup.rfq.bid_requests.common.parentOrgs[i] == null){
                            // Don't include null values when checking for the incumbents
                            nullitems++;
                        } else if (incumbentsArray.indexOf(abcsetup.rfq.bid_requests.common.parentOrgs[i]) == -1) {
                            incumbentsArray.push(abcsetup.rfq.bid_requests.common.parentOrgs[i]);
                        }
                    }
                }
                console.log('Null Vendor IDs: ',nullitems);
                if (incumbentsArray.length > 1){
                    abcsetup.alerts.flashMessage('Please ensure that there is only one supplier listed in the incumbent section or that the suppliers are part of the same vendor family.','danger');
                    $('.btn.submit').attr('title','Please ensure that there is only one supplier listed in the incumbent section or that the suppliers are part of the same vendor family.').attr('disabled',true);
                }
            }
        }, 1250);
    },

    /**
     * searchVendor
     *    search for vendor linked to an item
     */
    searchVendor: function(item_sap,action) {
        if (!($('#formulary_type').val() == 'PharmaGen' && $('#rfq_bid_type_id').val() == 15)) {
            return;
        }
        axios.get('/api/rfq/bid_requests/item_suppliers',{
            params: {
                sap_num: item_sap
            }
        }).then(response => {
            if (response.data.vendor) {
                var vendor = response.data.vendor;
                if(action == 'select') {
                    abcsetup.rfq.bid_requests.common.vendors.push(vendor);
                    $('#suppliers').find("option[value="+vendor+"]").prop('selected',true).trigger('change');
                } else if (action == 'unselect') {
                    var index = abcsetup.rfq.bid_requests.common.vendors.indexOf(vendor);
                    if (index > -1) {
                        abcsetup.rfq.bid_requests.common.vendors.splice(index, 1);
                    }

                    var index = abcsetup.rfq.bid_requests.common.vendors.indexOf(vendor);
                    if (index == -1) {
                        $('#suppliers').find("option[value="+vendor+"]").prop('selected',false).trigger('change');
                    }

                }
            }
        });
    }
}
